import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import PropTypes from 'prop-types'

import { validate } from '@models/custom_role'
import { RailsForm } from '@support/RailsForm'
import { wrapper } from '@support/AppContainer'
import Form from './Form'

export const New = ({ model }) => {
  return (
    <RailsForm
      component={FinalForm}
      action='create'
      url='/custom_roles'
      successUrl='/custom_roles'
      validate={validate}
      initialValues={model}
      render={(props) => (
        <Form
          {...props}
          title='Criar Papel'
        />
      )}
    />
  )
}

New.propTypes = {
  model: PropTypes.object
}

export default wrapper(New)
